import React, { useState } from "react";
import { Controller } from "react-hook-form";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { TextField, InputAdornment, IconButton } from "@mui/material";

const ConfirmedPasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(null);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const {
    control,
    getValues,
    watch,
    trigger,
    formState: { touchedFields },
  } = props.formController;

  return (
    <>
      <Controller
        name="password"
        control={control}
        defaultValue=""
        rules={{
          required: "Password is required.",
          validate: (value) => {
            return setPassword(value);
          },
        }}
        render={({ field, fieldState }) => {
          return (
            <TextField
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              label={props.labelNewPassword}
              required={true}
              error={fieldState.error !== undefined}
              helperText={fieldState.error?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={togglePasswordVisibility}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              {...field}
            />
          );
        }}
      />

      <Controller
        name="confirmPassword"
        control={control}
        defaultValue=""
        rules={{
          required: "Passwords must match.",
          validate: (value) => {
            if (value === password) return true;
            return "Passwords must match.";
          },
        }}
        render={({ field, fieldState }) => {
          return (
            <TextField
              type={showPassword ? "text" : "password"}
              autoComplete="off"
              label={props.labelConfirmNewPw}
              required={true}
              error={fieldState.error !== undefined}
              helperText={fieldState.error?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={togglePasswordVisibility}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              {...field}
            />
          );
        }}
      />
    </>
  );
};

export default ConfirmedPasswordInput;
